import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  saveTotalBillAmount,
  submitApproval,
  submitApprovalCghs,
  updateAllDocumentsData,
} from "../../../../apis/patientService";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import DocumentDeficiencyModal from "../../../../components/patient/DocumentDeficiencyModal";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import { message } from "antd";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import { IDocumentFields } from "../../../../interfaces/ICase";
import {
  fetchStepperData,
  getVisitStageStates,
} from "../../../../models/preAuthSlice";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import { Form } from "antd";
import dayjs from "dayjs";
import {
  fetchDoctorTypeList,
  intimateSubmitDischarge,
  intimateSubmitDischargeCghs,
  submitDischargeData,
  submitDischargeDataCghs,
  submitDischargeDataInEdgePro,
  submitDischargeDataInEdgeProCghs,
} from "../../../../models/DischargeSlice";

//cghs code
import DischargeCghs from "../../../../components/patient/Discharge/Cghs/DischargeCghs";
import {
  dischargeServiceCghs,
  fetchEnhancementProcedureCghs,
} from "../../../../apis/SchemeService/CGHS/cghsService";
import ConfirmSubmissionModalStage from "../../../../components/modals/ConfirmSubmissionModalStage";
import MultipleFilesPreviewModal from "../../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import BillAmountConfirmationModal from "../../Claim/CGHS/BillAmountConfirmationModal";
import { fetchProcedure } from "../../../../models/preAuthClaimSlice";
import { errorMessageModal } from "../../../../utils/modalMessage";

export interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
  requestDocument?: boolean;
  responseDocument?: boolean;
}

type DischargeCghsContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

const DischargeCghsContainer: FC<DischargeCghsContainerProps> = ({
  activeKey,
  sseData,
  sseUpdateCount
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients, enhancement, auth, preAuth, discharge } = useSelector(
    (state: RootState) => state
  );
  const [form] = Form.useForm();
  const {
    stepperData,
    currentStep,
    stageAllState,
    // schemePortalStatusList,
    portalData,
  } = useSelector((state: RootState) => state.preAuth);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [isApproved, setIsApproved] = useState<any>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [portalSubmission, setPortalSubmission] = useState(false);
  const [caseDischargeId, setCaseDischargeId] = useState<any>(null);
  const [caseDischargeData, setCaseDischargeData] = useState<any>();
  const [
    documentRequestResponseDocuments,
    setDocumentRequestResponseDocuments,
  ] = useState<any>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false); //for submit on portal
  const [isIntimating, setIsIntimating] = useState<boolean>(false); //for intimation of discharge button
  const [isSaving, setIsSaving] = useState<boolean>(false); //for saving and updating as draft
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [cghsProcedures, setCghsProcedures] = useState<any>([]);

  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);

  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
  const [loading, setLoading] = useState<boolean>(false);
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);

  const isDischargeTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId
    );

    return currentStage?.visitStage?.toUpperCase() === "DISCHARGE";
  };

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  const currentStageDetails = stepperData?.currentVisitStage;
  // const currentActiveStage = stepperData?.visitStages[currentStep];

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]))
  );

  useEffect(() => {
    if (caseDischargeData) {
      setPortalSubmission(caseDischargeData?.submitted);
    }
  }, [caseDischargeData]);

  const handleFileChange =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(true);
        }
        return e?.target?.files;
      }
    };

  // const handleFileChange = (documentType: string) => (e: any) => {
  //   const maxSize = 15 * 1024 * 1024;

  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   if (e?.file) {
  //     setSelectedFile({ file: e.file, documentType: documentType });
  //     setPreviewFile({
  //       url: URL.createObjectURL(e.file),
  //       name: e.file.name,
  //       showUpload: true,
  //       documentType: documentType,
  //     });
  //     setPreviewModalVisible(true);
  //   }
  //   return e?.target?.files;
  // };

  const handleFetchProcedureList = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const res = await fetchEnhancementProcedureCghs(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        setCghsProcedures(res);
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  useEffect(() => {
    handleFetchProcedureList();
  }, []);

  const fetchDocuments = async () => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );
        setDocumentTypes(AllDocumentList?.["Discharge"]);
      } catch (err) {
        // errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  const treatingDoctorTypeValue = Form.useWatch("treatingDoctorType", form);
  const treatingDoctorName = Form.useWatch("treatingDoctorName", form);

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
      "CGHS"
    ) {
      const data = {
        docType: treatingDoctorTypeValue,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      };
      dispatch(fetchDoctorTypeList(data));
    }
  }, [treatingDoctorTypeValue]);

  useEffect(() => {
    if (treatingDoctorName) {
      form.setFieldsValue({
        treatingDoctorRegistrationNo: treatingDoctorName?.split("~")[1],
        treatingDoctorContactNumber: treatingDoctorName?.split("~")[2],
        treatingDoctorQualification: treatingDoctorName?.split("~")[3],
      });
    }
  }, [treatingDoctorName]);

  const getDischargeData = async () => {
    try {
      const res = await dischargeServiceCghs.getDischargeData(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      );
      setCaseDischargeData(res);
      setCaseDischargeId(res?.id);
      setIsApproved(res?.approved);
      const updatedValues = {
        ...res,
        dateOfAdmission:
          res?.dateOfAdmission &&
          dayjs(res?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss", true).isValid()
            ? dayjs(res?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss")
            : null,
        dateOfDischarge:
          res?.dateOfDischarge &&
          dayjs(res?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss", true).isValid()
            ? dayjs(res?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss")
            : null,
        surgeryDate:
          res?.surgeryDate &&
          dayjs(res?.surgeryDate, "DD-MM-YYYY HH:mm:ss", true).isValid()
            ? dayjs(res?.surgeryDate, "DD-MM-YYYY HH:mm:ss")
            : null,
        dischargeFollowUpDate:
          res?.dischargeFollowUpDate &&
          dayjs(
            res?.dischargeFollowUpDate,
            "DD-MM-YYYY HH:mm:ss",
            true
          ).isValid()
            ? dayjs(res?.dischargeFollowUpDate, "DD-MM-YYYY HH:mm:ss")
            : null,
        radioButtonForDischargeAndDeath: res?.discharge
          ? "false"
          : res?.death
          ? "false"
          : null,
        covidPatientOrNot: res?.covidPatientOrNot ? "true" : "false",
        treatingDoctorName: res?.treatingDoctorName
          ? res?.treatingDoctorName +
            "~" +
            res?.treatingDoctorRegistrationNo +
            "~" +
            res?.treatingDoctorContactNumber +
            "~" +
            res?.treatingDoctorQualification
          : null,
      };

      form.setFieldsValue(updatedValues);
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getDischargeData();
      await fetchDocuments();
    };

    if (activeKey && activeKey?.length > 0 && isDischargeTabActive()) fetchData();
  }, [schemeMetaDataId, activeKey]);

  const fetchStepperForStatus = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      await dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  const fetchDataForSse = async () => {
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        // dispatch(
        //   getBasicDetails({
        //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        //   })
        // );
      }
      getDischargeData();
      fetchStepperForStatus();
      await getTimelineDetail();
      fetchDocuments();
    };
  
    useEffect(() => {
      if (sseData) {
        fetchDataForSse();
      }
    }, [sseData, sseUpdateCount]);

  const handleOpen = React.useCallback((docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  },[]);

  const handleCancelPreview = React.useCallback(() => {
    setPreviewDocument(false);
  },[]);

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];

    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });

    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };

  const handleUpload = async () => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file)
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  // const handleUpload = async () => {
  //   const CollectPostData = new FormData();
  //   if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //     CollectPostData.append(
  //       "hospitalId",
  //       patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //     CollectPostData.append(
  //       "patientId",
  //       patients?.fetchBasicDetails?.patientResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //     CollectPostData.append(
  //       "caseId",
  //       patients?.fetchBasicDetails?.casesResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //     CollectPostData.append(
  //       "visitId",
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
  //     );
  //   }
  //   CollectPostData.append("documentType", previewFile.documentType);

  //   if (selectedFile?.file) {
  //     CollectPostData.append("file", selectedFile?.file);
  //   }

  //   try {
  //     const documentRes = await dispatch(
  //       UploadDocument({
  //         formData: CollectPostData,
  //         accessToken: auth.accessToken || "",
  //       })
  //     ).unwrap();

  //     const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);

  //     setDocumentUrls(updatedDocuments);
  //     setPreviewModalVisible(false);
  //     message.success(
  //       `${documentRes?.documentLabelType} uploaded successfully`
  //     );
  //   } catch (error) {
  //     console.error("Failed to upload document:", error);
  //   }
  // };

  useEffect(() => {
    if (currentActiveStage?.visitStageId) {
      dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId })
      );
    }
  }, [currentActiveStage?.visitStageId]);

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId)
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      message.success("Document Downloaded successfully");
    } catch (error) {
      message.error("Download failed");
    }
  };

  const [isSavingTotalBillAmount, setIsSavingTotalBillAmount] = useState(false);

  const handleSaveBillAmount = React.useCallback(async () => {
    try {
      await form.validateFields(["totalBillAmount"]);
      const totalBillAmount = await form.getFieldsValue(true).totalBillAmount;

      if (caseId && visitId) {
        setIsSavingTotalBillAmount(true);
        const res = await saveTotalBillAmount(caseId, visitId, totalBillAmount);
        setIsSavingTotalBillAmount(false);
        successMessage("Bill Amount Saved Successfully");
        getDischargeData();
      }
    } catch (err: any) {
      if (err?.errorFields?.length > 0) {
        errorMessageModal("Please, fill bill amount before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
    } finally {
      setIsSavingTotalBillAmount(false);
    }
  },[caseId,visitId,form]);

  useEffect(() => {
    const requestResponseDocuments = {
      requestedDocuments: [] as Document[],
      responseDocuments: [] as Document[],
    };

    documentTypes?.forEach((document) => {
      if (document?.requestDocument) {
        requestResponseDocuments.requestedDocuments.push(document);
      } else if (document?.responseDocument) {
        requestResponseDocuments.responseDocuments.push(document);
      }
    });

    setDocumentRequestResponseDocuments(requestResponseDocuments);
  }, [documentTypes]);

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isDischargeTabActive()) {
      // fetchStepperForStatus();
      // getTimelineDetail();
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  useEffect(() => {
    const listOfUploadedDocuments = documentTypes?.flatMap(
      (item: any) =>
        item?.documentList?.map((doc: any) => ({
          id: doc?.id,
          documentName: doc?.documentName,
          documentType: doc?.documentType,
          documentUrl: doc?.documentUrl,
          documentLabelType: doc?.documentLabelType,
          deficiencyCheckStatus: doc?.deficiencyCheckStatus,
        })) || []
    );

    setDocumentUrls(listOfUploadedDocuments);
  }, [documentTypes]);

  const validateRequiredDocuments = (
    mandatoryDocuments: any,
    documentUrls: any
  ) => {
    for (const doc of mandatoryDocuments) {
      if (doc.required && doc.visible) {
        const isUploaded = documentUrls?.some(
          (uploadedDoc: any) => uploadedDoc.documentLabelType === doc.label
        );
        if (!isUploaded) {
          return false;
        }
      }
    }
    return true;
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
        patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName &&
        patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        dispatch(
          fetchProcedure({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          })
        );
      }
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
  ]);

  const handleSubmit = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = {
        ...values,
        dateOfAdmission: values?.dateOfAdmission
          ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        dateOfDischarge: values?.dateOfDischarge
          ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        surgeryDate: values?.surgeryDate
          ? dayjs(values?.surgeryDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        dischargeFollowUpDate: values?.dischargeFollowUpDate
          ? dayjs(values?.dischargeFollowUpDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        discharge:
          values?.radioButtonForDischargeAndDeath === "true" ? false : true,
        death:
          values?.radioButtonForDischargeAndDeath === "true" ? true : false,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        documentUrls,
        treatingDoctorName: values?.treatingDoctorName?.split("~")?.[0],
      };

      setIsSaving(true);
      const res = await dispatch(
        submitDischargeDataInEdgeProCghs({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          caseDischargeId,
          dischargeData: updatedValues,
        })
      );
      setIsSaving(false);

      if (submitDischargeDataInEdgeProCghs.fulfilled.match(res)) {
        successMessage("Discharge Saved Successfully");
        setConfirmationModal(false);
        setIsSaving(false);
        await getDischargeData();
        await fetchDocuments();
        await fetchStepperForStatus();
        await getTimelineDetail();
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      } else if (submitDischargeDataInEdgeProCghs.rejected.match(res)) {
        errorMessageModal("Please, Try again later");
        setIsSaving(false);
        setConfirmationModal(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill all details before submitting");
      } else {
        errorMessageModal("Please, Try again later");
      }
      setIsSaving(false);
      setConfirmationModal(false);
    }
  };

  const handleAttachDocuments = async (updatedDocumentUrls: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    payloadSchema["caseDischargeAttachments"] = updatedDocumentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    const updatedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    payloadSchema["caseDischargeAttachments"] = updatedDocumentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`Response documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleIntimate = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        const updatedValues = {
          ...values,
          dateOfAdmission: values?.dateOfAdmission
            ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          dateOfDischarge: values?.dateOfDischarge
            ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          surgeryDate: values?.surgeryDate
            ? dayjs(values?.surgeryDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          dischargeFollowUpDate: values?.dischargeFollowUpDate
            ? dayjs(
                values?.dischargeFollowUpDate,
                "DD-MM-YYYY HH:mm:ss"
              ).format("DD-MM-YYYY HH:mm:ss")
            : null,
          discharge:
            values?.radioButtonForDischargeAndDeath === "true" ? false : true,
          death:
            values?.radioButtonForDischargeAndDeath === "true" ? true : false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          documentUrls,
          treatingDoctorName: values?.treatingDoctorName?.split("~")?.[0],
          action: "intimate",
        };
        setIsIntimating(true);
        const res = await dispatch(
          intimateSubmitDischargeCghs({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalMetaDataId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            intimationData: updatedValues,
          })
        );
        setIsIntimating(false);
        if (intimateSubmitDischargeCghs.fulfilled.match(res)) {
          successMessage("Discharge Sent To QC Successfully");
          setConfirmationModal(false);
          await getDischargeData();
          await fetchDocuments();
          await fetchStepperForStatus();
          await getTimelineDetail();
          // setConfirmationModal(false);
          if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
            dispatch(
              getBasicDetails({
                id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              })
            );
          }
        } else if (intimateSubmitDischargeCghs.rejected.match(res)) {
          errorMessageModal("Please, Try again later");
          setIsIntimating(false);
          setConfirmationModal(false);
        }
      } else {
        errorMessageModal("Please, Upload all required documents");
        setIsIntimating(false);
        setConfirmationModal(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill all details before submitting");
      } else {
        errorMessageModal("Please, Try again later");
      }
      setIsIntimating(false);
      setConfirmationModal(false);
    }
  };

  const handleSubmitOnPortal = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        const updatedValues = {
          ...values,
          dateOfAdmission: values?.dateOfAdmission
            ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          dateOfDischarge: values?.dateOfDischarge
            ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          surgeryDate: values?.surgeryDate
            ? dayjs(values?.surgeryDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          dischargeFollowUpDate: values?.dischargeFollowUpDate
            ? dayjs(
                values?.dischargeFollowUpDate,
                "DD-MM-YYYY HH:mm:ss"
              ).format("DD-MM-YYYY HH:mm:ss")
            : null,
          discharge:
            values?.radioButtonForDischargeAndDeath === "true" ? false : true,
          death:
            values?.radioButtonForDischargeAndDeath === "true" ? true : false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          documentUrls,
          treatingDoctorName: values?.treatingDoctorName?.split("~")?.[0],
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        setIsSubmitting(true);
        const res = await dispatch(
          submitDischargeDataCghs({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalMetaDataId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            caseDischargeId,
            dischargeData: updatedValues,
          })
        );

        setIsSubmitting(false);
        if (submitDischargeDataCghs.fulfilled.match(res)) {
          successMessage("Discharge Submitted Successfully");
          setConfirmationModal(false);
          await getDischargeData();
          await fetchDocuments();
          await fetchStepperForStatus();
          await getTimelineDetail();
          setConfirmationModal(false);
          if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
            dispatch(
              getBasicDetails({
                id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              })
            );
          }
        } else if (submitDischargeDataCghs.rejected.match(res)) {
          setIsSubmitting(false);
          errorMessageModal("Please, Try again later");
          setConfirmationModal(false);
        }
      } else {
        errorMessageModal("Please, Upload all required documents");
        setIsSubmitting(false);
        setConfirmationModal(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill all details before submitting");
      } else {
        errorMessageModal("Please, Try again later");
      }
      setIsSubmitting(false);
      setConfirmationModal(false);
    }
  };

  const handleApprove = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        const updatedValues = {
          ...values,
          dateOfAdmission: values?.dateOfAdmission
            ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          dateOfDischarge: values?.dateOfDischarge
            ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          surgeryDate: values?.surgeryDate
            ? dayjs(values?.surgeryDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          dischargeFollowUpDate: values?.dischargeFollowUpDate
            ? dayjs(
                values?.dischargeFollowUpDate,
                "DD-MM-YYYY HH:mm:ss"
              ).format("DD-MM-YYYY HH:mm:ss")
            : null,
          discharge:
            values?.radioButtonForDischargeAndDeath === "true" ? false : true,
          death:
            values?.radioButtonForDischargeAndDeath === "true" ? true : false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          documentUrls,
          treatingDoctorName: values?.treatingDoctorName?.split("~")?.[0],
        };
        setIsApprovedInitiated(true);
        const formData = {
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          stage: "Discharge",
          approved: true,
          dischargeRequest: updatedValues,
          caseDischargeId,
        };
        const res = await submitApprovalCghs(formData);
        setIsApproved(true);
        setIsApprovedInitiated(false);
        message.success("Discharge Approved Successfully");
        setConfirmationModal(false);
        await getTimelineDetail();
        await fetchStepperForStatus();
        await getDischargeData();
        await fetchDocuments();
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      } else {
        errorMessageModal("Please, Upload all required documents");
        setIsApprovedInitiated(false);
        setIsApproved(false);
        setConfirmationModal(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, fill all details before submitting");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      } else {
        errorMessageModal("Please, Try again later");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      }
      setConfirmationModal(false);
    }
  };

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [confirmationState, setConfirmationState] = useState<string>("");

  const handleSaveConfirmationModal = async (confirmationState: string) => {
    if (confirmationState === "intimate") {
      if (auth?.role?.role !== "FO_STAFF") {
        try {
          await form.validateFields();
        } catch (err: any) {
          if (err?.errorFields) {
            errorMessage("Please, Fill all details before submitting");
          } else {
            errorMessage("Please, Try again later");
          }
          return;
        }
      }
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls,
        )
      ) {
        errorMessage("Please, Upload all required documents");
        return;
      }
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "save") {
      setTitle("Do You want to save Discharge ?");
    } else if (confirmationState === "update") {
      setTitle("Do You want to update Discharge ?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send Discharge for QC ?");
    } else if (confirmationState === "submit") {
      setTitle("Do You want to submit Discharge ?");
    } else if (confirmationState === "approve") {
      setTitle("Do You want to approve Discharge ?");
    }
  };

  const handleSave = async () => {
    if (confirmationState === "save") {
      await handleSubmit();
    } else if (confirmationState === "update") {
      await handleSubmit();
    } else if (confirmationState === "intimate") {
      await handleIntimate();
    } else if (confirmationState === "submit") {
      await handleSubmitOnPortal();
    } else if (confirmationState === "approve") {
      await handleApprove();
    }

    setConfirmationModal(false);
  };

  const [isAmountModal, setIsAmountModal] = useState<boolean>(false);

  const totalBillAmount = Form.useWatch("totalBillAmount", form);

  const [totalProcedureAmount, setTotalProcedureAmount] = useState(0);

  useEffect(() => {
    if (cghsProcedures?.length > 0) {
      const total = cghsProcedures?.reduce((sum: any, procedure: any) => {
        const amount = procedure?.procedureName
          ?.toLowerCase()
          ?.includes("unspecified")
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);

        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);

      setTotalProcedureAmount(total);
    }
  }, [cghsProcedures]);

  useEffect(() => {
    const billAmount = totalBillAmount ? parseFloat(totalBillAmount) : 0;

    if (!totalBillAmount || isNaN(billAmount) || billAmount <= 0) {
      setIsAmountModal(false);
      return;
    }

    if (
      (billAmount > totalProcedureAmount && totalProcedureAmount > 0) ||
      billAmount > 3000
    ) {
      setIsAmountModal(true);
    } else {
      setIsAmountModal(false);
    }
  }, [totalBillAmount, totalProcedureAmount]);

  return (
    <>
      <DischargeCghs
        documentTypes={documentTypes}
        documentUrls={documentUrls}
        handleFileChange={handleFileChange}
        handleOpen={handleOpen}
        form={form}
        handleSubmit={handleSubmit}
        handleIntimate={handleIntimate}
        handleSubmitOnPortal={handleSubmitOnPortal}
        handleApprove={handleApprove}
        isApproved={isApproved}
        isApprovedInitiated={isApprovedInitiated}
        documentRequestResponseDocuments={documentRequestResponseDocuments}
        loading={loading}
        handleSaveData={handleSaveData}
        activeKey={activeKey}
        currentVisitStage={preAuth?.stepperData?.currentVisitStage}
        isSubmitting={isSubmitting}
        isIntimating={isIntimating}
        isSaving={isSaving}
        currentActiveStage={currentActiveStage}
        handleSaveConfirmationModal={handleSaveConfirmationModal}
        portalSubmission={portalSubmission}
        caseDischargeId={caseDischargeId}
        caseDischargeData={caseDischargeData}
        doctorTypeNameList={discharge?.doctorTypeList}
        uploadFileList={uploadFileList}
        cghsProcedures={cghsProcedures}
        handleSaveBillAmount={handleSaveBillAmount}
        isSavingTotalBillAmount={isSavingTotalBillAmount}
      />
      {selectedFile?.file && !selectedFiles?.length && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => setPreviewModalVisible(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.lastModified || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        isSubmittedStatus={portalSubmission}
        isIntimated={caseDischargeData?.intimated}
        fetchingDeficiencyData={fetchingDeficiencyData}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
        isHospitalBillDischargeSummary={true}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
      />

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={
          isSaving || isIntimating || isApprovedInitiated || isSubmitting
        }
      />

      <BillAmountConfirmationModal
        isModalVisible={isAmountModal}
        handleCancel={() => {
          setIsAmountModal(false);
        }}
        handleOk={() => {
          setIsAmountModal(false);
        }}
        text={
          "Total bill Amount is greater than total preauth amount. Please, Create Enhancement First"
        }
        showCloseButton={true}
      />
    </>
  );
};

export default DischargeCghsContainer;
